import { createContext, useContext } from 'react';

import type { IntegrationApiRequests } from './integrations-types';

const IntegrationsApiContext = createContext<IntegrationApiRequests>({} as IntegrationApiRequests);

export const useIntegrationsApi = () => {
  return useContext(IntegrationsApiContext);
};

export const IntegrationsProvider = ({
  children,
  value,
}: {
  children: React.ReactNode;
  value: IntegrationApiRequests;
}) => {
  return (
    <IntegrationsApiContext.Provider value={value}>{children}</IntegrationsApiContext.Provider>
  );
};

export type { IntegrationApiRequests } from './integrations-types';
